import { useEffect } from "react";
import config from "./Config";
import {
  registerActiveTab,
  teardownActiveTabSession,
} from "../../utils/activeTabSession";

export default function ActiveTabSessionSync() {
  useEffect(() => {
    if (!localStorage.getItem("token") && !localStorage.getItem("accessToken")) {
      return undefined;
    }
    registerActiveTab();
    const disposeUnload = teardownActiveTabSession();
    const iv = setInterval(() => {
      if (!localStorage.getItem("token") && !localStorage.getItem("accessToken")) {
        return;
      }
      registerActiveTab();
    }, 3000);
    return () => {
      clearInterval(iv);
      disposeUnload();
    };
  }, []);
  return null;
}
